module.exports = __webpack_public_path__ + "static/media/1_Piattos.dceea9d5.png";